import { FC, useCallback, useState } from 'react';

import style from './Criteria.css';
import { CriteriaContent } from './CriteriaContent';
import { CriteriaTabs } from './CriteriaTabs';

export const Criteria: FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = useCallback((index: number) => setActiveTab(index), []);

  return (
    <section className={style['criteria']}>
      <div className={style['inner']}>
        <h2 className={style['heading']}>Точные критерии программы зависят от вашего типа размещения на Циан</h2>
        <CriteriaTabs activeIndex={activeTab} onTabChange={handleTabChange} />
        <CriteriaContent activeTab={activeTab} />
      </div>
    </section>
  );
};
